<template>
  <div class="page">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'文件下载'"/>
      </div>
    </div>
    <div  style="margin-top: 10px;">
    <div style="width: 1200px;margin: auto;background-color: #FFFFFF;">
      <div style="display: flex">
      <div style="width: 360px;margin-top: 20px;margin-left: 20px">
        <el-tag style="width: 100%;height: 40px">
          <span style="display: inline-block;font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{ catalogTitle }}</span>
        </el-tag>
      </div>
      <div style="width: 780px;margin-left: 20px;margin-top: 20px;display: flex" class="cha">
      <el-input  v-model="pageQuery.filename" class="filter-item"  placeholder="文件名称" clearable/>
      <el-button style="height: 40px;border-radius:4px;"  type="primary" icon="el-icon-search" @click="queryFilePage">查询</el-button>

      </div>
      </div >
      <div style="margin-top: 20px;margin-left: 20px">
        <div style="display: flex">
        <div style="width: 360px" >
      <el-scrollbar ref="treeDiv" class="tree-container" style="min-height: 500px">
        <el-tree
          style="min-height: 300px"
          id="tree" class="tree"
          :indent="0"
          :data="dataList" :props="prop" @node-click="select"  :default-expand-all="true">

        </el-tree>
      </el-scrollbar>
        </div>
          <div style="width: 780px;margin-left: 20px" class="tab">
      <el-scrollbar style="min-height: 500px">
        <el-table
          v-loading="loading"
          :data="page.list"
          row-key="id"
          border
          stripe
          style=" width: 100%; "
          :row-style="{height: '70px'}"
          :header-cell-style='headerStyle'
        >
          <el-table-column label="文件名称"   prop="name" align="left" :show-overflow-tooltip="true">
            <template  slot-scope="{row}">
              <span >{{ row.rename }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属目录"  prop="name" align="left" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.catalogName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注"  prop="name" align="left" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上传者" prop="code" align="left" width="80" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上传时间"  prop="status" align="left" width="160" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span> {{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"  align="left" width="100px">
            <template slot-scope="{row}">
              <el-button type="primary" icon="el-icon-download" size="small" @click="downloadFile(row.ossName)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :total="page.totalRow" :current-page.sync="page.pageNumber" :page-size.sync="page.pageSize"
                       layout="total, prev, pager, next, jumper"
                       @current-change="queryFilePage"/>
      </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import request from "../../utils/request";
import NavigationBar from "./compoment/navigationBar";


export default {
  name:'fileDownLoad',
  components: {NavigationBar},
  data(){
    return{
      renderContent:function (h,{node,data,store}) {
        let addElement = arguments[0];
        if(data.children == 0){
          return addElement('span',[
            addElement('i',{class:"el-icon-tickets"}),
            addElement('span',"    "),
            addElement('span',arguments[1].node.label)
          ]);
        }else{
          return addElement('span',[
            addElement('i',{class:"el-icon-folder"}),
            addElement('span',"    "),
            addElement('span',arguments[1].node.label)
          ]);
        }
      },

      headerStyle:{
        'height':'50px'
      },
      input: "",
      imageUrlTop:require('../../../static/image/home.jpg'),
      systemName:getSystemName(),
      loading:true,
      catalogTitle:'',
      dataList:[],
      page: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      pageQuery: {
        pageNumber: 1,
        pageSize: 20,
        catalogId: '',
        belong: getSystemId(),
        filename: ''
      },
      prop:{
        children: 'children',
        label: 'name'
      }

    }
  },

  methods:{
    select(data,node){
      this.pageQuery.filename=''
      this.catalogTitle = data.name
      this.pageQuery.catalogId=data.id
      this.queryFilePage()
    },
    queryFilePage(data) {
      this.loading = true
      if (data) {
        this.pageQuery.pageNumber = data.page
        this.pageQuery.pageSize = data.limit
      }
      request.post('/portalFile/page', this.pageQuery).then(rsp => {
        if (rsp.resultCode === '0') {
          this.page = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    downloadFile(filename) {
      window.location.href = config.VUE_APP_BASE_API + `/attachmentByDir?name=${filename}&type=portalDownload`
    },
    /**
     * 目录查询
     */
    queryCatalog(){
      request({
        url:'/portalFile/listCatalog',
        methods: 'get',
        params:{
          belong:this.belong,
          name:''
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
         this.dataList=rsp.data

        }else {
          this.$message({
            message:'查询目录错误',
            type:'error',
            duration:2000
          })
        }
      })
    },
    /**
     * 跳转标准查询页
     */
    toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },
  },
  mounted(){
    document.title = this.systemName;
    this.belong=getSystemId();
    this.queryFilePage();
    this.queryCatalog();
  },


}
</script>
<style scoped>

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-table td, .el-table th.is-leaf {
    border-bottom: 4px solid #EBEEF5;
}
.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px solid #d1d2d3;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px solid #d1d2d3;
  height: 20px;
  top: 12px;
  width: 24px;
}

.tree-container {
}
.page{
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size:100% 775px;
}
.cha /deep/ .el-input__inner {
  width: 680px;
  height: 40px;
}
.tab /deep/ .el-table .cell {
font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  text-align: center;
  color: #666666;
}
</style>
<style>
.page .el-scrollbar .el-scrollbar__wrap {overflow-x: hidden;}
.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

/*//有子节点 且未展开*/
.el-tree .el-icon-caret-right:before {
  background: url('../../../src/assets/image/folder.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//有子节点 且已展开*/
.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url('../../../src/assets/image/open.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//没有子节点*/
.el-tree .el-tree-node__expand-icon.is-leaf::before {
  background: url('../../../src/assets/image/file.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/fileDownLoad.vue